import { render, staticRenderFns } from "./BookingPositionInboxList.vue?vue&type=template&id=33036d14&"
import script from "./BookingPositionInboxList.vue?vue&type=script&lang=js&"
export * from "./BookingPositionInboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports